import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RegExp } from 'src/app/core/config/regex';
import { Context } from 'src/app/shared/models/context';
import { Leave } from 'src/app/shared/models/domain';
import { AppearanceService } from 'src/app/shared/services/appearance.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DataService } from 'src/app/shared/services/data.service';

@Component({
  selector: 'app-manage-leave',
  templateUrl: './manage-leave.component.html',
  styleUrls: ['./manage-leave.component.scss']
})
export class ManageLeaveComponent implements OnInit {
  @Input() leave: Leave;
  @Input() context: Context;
  @Input() leaves: Leave[] = [];
  public submitted: boolean = false;
  private modified: boolean = false;
  public reasons: string[] = [];
  public types: string[] = [];
  public leaveForm: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private commonService: CommonService,
    private appearanceService: AppearanceService,
    private datePipe: DatePipe,
    private dataService:DataService

  ) { }

  ngOnInit(): void {
    this.appearanceService.getVacation().subscribe((reasons) => (this.reasons = reasons));
    this.appearanceService.getSanction().subscribe((types) => (this.types = types));
    this.setLeaveForm(this.leave);
  }

  public setLeaveForm(leave?: Leave) {
    if (!leave)
      leave = {
        id: null,
        appliedBy: {
          id: this.context.employeeId,
        },
        appliedFor: {
          id: this.context.employeeId,
        },
        appliedOn: new Date(),
        appliedFrom: this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
        appliedTo: null,
        reason: null,
        remarks: null,
        status: 'APPLIED',
        approvedBy: null,
        approvedOn: new Date(),
        comments: '',
        partial: false,
        beforeNoon: false,
        disabled: false,
        leaveType: 'OPTIONAL_HOLIDAY',
      } as Leave;
    this.leaveForm = this.fb.group({
      id: this.fb.control(leave.id, null),
      appliedOn: this.fb.control(this.datePipe.transform(new Date(), 'yyyy-MM-dd'), []),
      appliedFrom: this.fb.control(this.datePipe.transform(leave.appliedFrom ? leave.appliedFrom : '', 'yyyy-MM-dd'), [Validators.required]),
      appliedTo: this.fb.control(this.datePipe.transform(leave.appliedTo ? leave.appliedTo : '', 'yyyy-MM-dd'), [Validators.required]),
      leaveType: this.fb.control(leave?.leaveType || leave.leaveType || '', [Validators.required]),
      reason: this.fb.control(leave?.reason || leave.reason || '', [Validators.required]),
      remarks: this.fb.control(leave.remarks, [Validators.required,Validators.pattern(RegExp.label)]),
      status: this.fb.control(leave.status || 'APPLIED'),
      beforeNoon: this.fb.control(leave.beforeNoon),
      approvedOn: this.fb.control(new Date(), []),
      comments: this.fb.control(leave.comments, []),
      partial: this.fb.control(leave?.partial, []),
      disabled: this.fb.control(leave.disabled, []),
      appliedBy: this.fb.group({ id: this.fb.control(leave?.appliedBy?.id || '', [Validators.required]), }),
      appliedFor: this.fb.group({ id: this.fb.control(leave?.appliedFor?.id || '', [Validators.required]), }),
    });
    this.leaveForm.valueChanges.subscribe(value => this.modified = true);
  }

  get l() {
    return this.leaveForm.controls;
  }

  public applyHalfDay(checked: any) {
    this.l['beforeNoon'].setValue(checked ? true : false);
  }

  public saveLeave(inProgress?: any) {
    this.submitted = true;
    if (this.leaveForm.valid) {
      let leave: Leave = this.leaveForm.value;
      leave.appliedBy.id = this.context.employeeId;
      leave.appliedFor.id = this.context.employeeId;
      leave.status = 'APPLIED';
      if (!this.modified) {
        this.activeModal.close(false);
        this.commonService.setToastr(200, `Leave ${leave.id} has been updated successfully!`);
        return;
      }
      inProgress.value = true;
      if (leave.id) {
        this.appearanceService.tocheckIfLeaveIsApplicable(this.leave.id).subscribe((check: boolean) => {
          if (!check) {
            this.commonService.setToastr(500, 'Leave cannot be edited.');
            inProgress.value = false;
          } else {
            this.appearanceService.updateLeave(leave.id, leave).subscribe({
              next: (response: Leave) => {
                if (response) {
                  this.dataService.reInitNotification();
                  this.activeModal.close(response);
                  this.commonService.setToastr(200, `Leave has been updated successfully!`);
                } else {
                  inProgress.value = false;
                  this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
                }
              },
              error: (error: HttpErrorResponse) => {
                inProgress.value = false;
                this.commonService.setToastr(500, error?.error?.name || error.error);
              },
            });
          }
        })
      } else {
        this.appearanceService.verifyEmployeeReportTo(this.context.employeeId).subscribe((check: boolean) => {
          if (!check) {
            this.commonService.setToastr(500, 'Looks like you don\'t have a reporting manager assigned. Please check with HR to apply for leave.');
            inProgress.value = false;
          } else {
            this.appearanceService.createLeave(leave).subscribe({
              next: (response: Leave) => {
                if (response) {
                  this.dataService.reInitNotification();
                  this.activeModal.close(response);
                  this.commonService.setToastr(200, `Leave has been applied successfully!`);
                } else {
                  inProgress.value = false;
                  this.commonService.setToastr(500, 'Looks like you don\'t have a reporting manager assigned. Please check with HR to apply for leave.');
                }
              },
              error: (error: HttpErrorResponse) => {
                inProgress.value = false;
                this.commonService.setToastr(500, error?.error?.name || error.error);
              },
            });
          }
        });
      }
    }
  }
}
